(function AddVendorSelectedTravelers($, Adzuki)
{
	"use strict";

	var AddVendorSelectedTravelers = {};

	var _removeSelectedTraveler;

	// eslint-disable-next-line no-array-constructor
	var travelers = new Array();

	AddVendorSelectedTravelers.addTraveler = function addTraveler(new_traveler)
	{
		var name_chunks;

		$.each(travelers, function iterator(i, traveler) {
			if (typeof traveler !== 'undefined' && traveler['client_id'] === new_traveler['client_id']) {
				return false;
			}
		});

		if (new_traveler['name'].indexOf('@') !== -1) {
			name_chunks = new_traveler['name'].split(' - ');
			name_chunks.pop();

			new_traveler['name'] = name_chunks.join(' - ');
		}

		travelers.push(new_traveler);

		AddVendorSelectedTravelers.buildSelectedTravelers();
	};

	AddVendorSelectedTravelers.buildSelectedTravelers = function buildSelectedTravelers()
	{
		var $selected_travelers    = $('.selected-travelers'),
		    traveler_count         = 1,
		    sp_html,
		    spcid_html = '';

		sp_html  = '<span class="recipient remove-all" id="remove-all">\n';
		sp_html += '	<span data-toggle="tooltip" data-placement="right" title="" data-original-title="Remove All">\n';
		sp_html += '		<i class="'+Adzuki.FaIcon.getIconStyle('delete')+'"></i>\n';
		sp_html += '	</span>\n';
		sp_html += '</span>\n';

		$.each(travelers, function iterator(i, traveler) {
			if (typeof traveler !== 'undefined') {
				sp_html += '<span class="recipient">\n';
				sp_html += '	<span class="remove" data-type="' + traveler['type'] + '" data-client-id="' + traveler['client_id'] + '"><i class="'+Adzuki.FaIcon.getIconStyle('close')+'"></i></span>\n';
				sp_html += '	<span class="title"><strong>Traveler ' + traveler_count + ':</strong> ' + traveler['name'] + '</span>\n';
				sp_html += '</span>\n';

				spcid_html += '<input type="hidden" name="form_component_data[ReservationAddTravelVendorDetails][selected_travelers][]" value="' + traveler['client_id'] + '">\n';

				traveler_count++;
			}
		});

		if (traveler_count > 1) {
			$selected_travelers.html(sp_html);
			$('.selected-traveler-client-ids').html(spcid_html);
			$('.no-travelers-selected').addClass('hidden');
			$selected_travelers.removeClass('hidden');

			$selected_travelers.find('.remove-all').on('click', function click(e) {
				AddVendorSelectedTravelers.resetSelectedTravelers();
			});

			$selected_travelers.find('.remove').on('click', function click(e) {
				_removeSelectedTraveler($(e.target).parent());
				AddVendorSelectedTravelers.buildSelectedTravelers();
			});
		} else {
			$selected_travelers.addClass('hidden');
			$('.no-travelers-selected').removeClass('hidden');
			$('.selected-traveler-client-ids').html('');
		}
	};

	AddVendorSelectedTravelers.removeSelectedTraveler = function removeSelectedTraveler(client_id)
	{
		$.each(travelers, function iterator(i, traveler) {
			if (typeof traveler !== 'undefined' && traveler['client_id'] === client_id.toString()) {
				delete travelers[i];

				return false;
			}
		});

		AddVendorSelectedTravelers.buildSelectedTravelers();
	};

	AddVendorSelectedTravelers.resetSelectedTravelers = function resetSelectedTravelers()
	{
		$('.selected-travelers').find('.remove').each(function iterator(i, selected_traveler) {
			_removeSelectedTraveler($(selected_traveler));
		});

		AddVendorSelectedTravelers.buildSelectedTravelers();
	};

	_removeSelectedTraveler = function _removeSelectedTraveler($selected_traveler)
	{
		if ($selected_traveler.data('type') === 'recommended') {
			$('.recommended-traveler[value=' + $selected_traveler.data('client-id') + ']').prop('checked', false);
		}

		$.each(travelers, function iterator(i, traveler) {
			if (typeof traveler !== 'undefined' && traveler['client_id'] === $selected_traveler.data('client-id').toString()) {
				delete travelers[i];

				return false;
			}
		});
	};

	Adzuki.AddVendorSelectedTravelers = AddVendorSelectedTravelers;

}(jQuery, window.Adzuki || {}));
